const PHYLUMS = Object.freeze({
  p__Firmicutes_A: {
    name: 'Firmicutes_A',
    color: '#8DD3C7'
  },
  p__Bacteroidetes: {
    name: 'Bacteroidetes',
    color: '#CEECBB'
  },
  p__Proteobacteria: {
    name: 'Proteobacteria',
    color: '#F5F5B8'
  },
  p__Actinobacteria: {
    name: 'Actinobacteria',
    color: '#D0CDCE'
  },
  p__Firmicutes: {
    name: 'Firmicutes',
    color: '#CFA9BC'
  },
  p__Firmicutes_C: {
    name: 'Firmicutes_C',
    color: '#F28880'
  },
  p__Verrucomicrobia: {
    name: 'Verrucomicrobia',
    color: '#C6949B'
  },
  p__Cyanobacteria: {
    name: 'Cyanobacteria',
    color: '#80B1D3'
  },
  p__Desulfobacterota: {
    name: 'Desulfobacterota',
    color: '#C7B292'
  },
  p__Fusobacteria: {
    name: 'Fusobacteria',
    color: '#F2BA63'
  },
  p__Epsilonbacterota: {
    name: 'Epsilonbacterota',
    color: '#C8D266'
  },
  p__Firmicutes_B: {
    name: 'Firmicutes_B',
    color: '#C7D98C'
  },
  p__Euryarchaeota: {
    name: 'Euryarchaeota',
    color: '#F1CFD3'
  },
  p__Thermoplasmatota: {
    name: 'Thermoplasmatota',
    color: '#EDD2DF'
  },
  p__Synergistetes: {
    name: 'Synergistetes',
    color: '#D9D9D9'
  },
  p__Elusimicrobia: {
    name: 'Elusimicrobia',
    color: '#2b6f3d'
  },
  p__Spirochaetes: {
    name: 'Spirochaetes',
    color: '#FF5733'
  }
})

export default PHYLUMS


//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/src/model/phylum.js
// module id = xj7/
// module chunks = 0